import type React from "react";

interface IssueCardProps {
  title: string;
  description: string;
  recommendation: string;
  recommendationLink: string;
  imageAlt: string;
  imageSrc: string;
}

const IssueCard: React.FC<IssueCardProps> = ({
  title,
  description,
  recommendation,
  recommendationLink,
  imageAlt,
  imageSrc,
}) => {
  return (
    <div className="temomi-card flex flex-row md:flex-col items-center md:items-center text-left md:text-center p-4 md:p-8 h-full hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[var(--temomi-red)] bg-white relative group rounded-2xl md:rounded-[2rem] overflow-hidden gap-4 md:gap-0">
      <div className="relative shrink-0 group-hover:scale-105 transition-transform duration-300 md:mb-6">
        <div className="absolute inset-0 bg-yellow-200 rounded-full blur-2xl opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
        <img
          src={imageSrc}
          className="relative rounded-full w-20 h-20 md:w-40 md:h-40 object-contain p-1 bg-orange-50 border-2 md:border-4 border-white shadow-md md:shadow-lg group-hover:shadow-xl transition-shadow"
          alt={imageAlt}
          width="160"
          height="160"
          loading="lazy"
        />
      </div>

      <div className="flex-1 flex flex-col items-start md:items-center relative z-10 w-full">
        <h3 className="text-sm md:text-xl font-bold text-gray-900 mb-2 md:mb-4 leading-snug md:min-h-[3.5em] flex items-center md:justify-center group-hover:text-[var(--temomi-red)] transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 text-xs md:text-sm leading-relaxed mb-3 md:mb-6 flex-1 md:border-t border-dashed border-gray-200 md:pt-4 w-full">
          {description}
        </p>
        <a
          href={recommendationLink}
          className="inline-flex items-center justify-center px-4 py-2 md:px-6 md:py-3 rounded-lg md:rounded-xl bg-gradient-to-r from-[var(--temomi-red)] to-orange-500 text-white text-xs md:text-sm font-bold shadow-sm md:shadow-md hover:shadow-lg hover:translate-y-[-2px] transition-all duration-300 w-full group-hover:from-red-600 group-hover:to-orange-600"
        >
          {recommendation}
        </a>
      </div>
    </div>
  );
};

export default IssueCard;
